var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { config, components } from "./follow-query-base/";
var collectionManageModule = namespace("collection-manage");
var FollowQueryBase = /** @class */ (function (_super) {
    __extends(FollowQueryBase, _super);
    function FollowQueryBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabsConfig = config;
        _this.currentComponent = "FollowAllQueryMini";
        return _this;
    }
    FollowQueryBase.prototype.onRecordCountChange = function () {
        this.currentComponent = "FollowAllQueryMini";
    };
    __decorate([
        collectionManageModule.State
    ], FollowQueryBase.prototype, "caseId", void 0);
    __decorate([
        collectionManageModule.State
    ], FollowQueryBase.prototype, "recordCount", void 0);
    __decorate([
        collectionManageModule.State
    ], FollowQueryBase.prototype, "currentCase", void 0);
    __decorate([
        Watch("recordCount")
    ], FollowQueryBase.prototype, "onRecordCountChange", null);
    FollowQueryBase = __decorate([
        Component({
            components: components
        })
    ], FollowQueryBase);
    return FollowQueryBase;
}(Vue));
export default FollowQueryBase;
